module.exports = __webpack_public_path__ + "static/media/SID DataIKU.254891ab.jpg";